import React, { Component } from "react";

/* Others */
import * as Loader from "react-loader-spinner";
/* Styles */
import "./Loading.css";

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: null,
      loading: false,
    };
  }


  render() {
    return (
      <div className="loading-card">
        <Loader.TailSpin
      type="ThreeDots"
      color="#D42B4C"
      height={80}
      width={80}
      timeout={10000}
    />
      </div>
    );
  }
}

export default Loading;
